import React from 'react';
import { DataTableEllipsisCell } from '@atoms';
import { Flex } from '@mixins';
import { theme } from '@styles';
import { dayjs } from '@utils';
import InvoiceCell from './InvoiceCell';

export const getColumns = isInvoiceColumnVisible => [
  {
    id: 1,
    flex: 1,
    field: 'title',
    sortable: false,
    renderHeader: () => (
      <DataTableEllipsisCell fontSize={['10px', '10px', '12px', '14px']} color={theme.color.black} fontWeight={600}>
        Package
      </DataTableEllipsisCell>
    ),
    renderCell: ({ value }) => (
      <DataTableEllipsisCell fontSize={['8px', '10px', '10px', '12px']} color={theme.color.black}>
        {value}
      </DataTableEllipsisCell>
    ),
  },
  {
    id: 2,
    field: 'startDate',
    flex: 1,
    sortable: false,
    renderHeader: () => (
      <DataTableEllipsisCell fontSize={['10px', '10px', '12px', '14px']} color={theme.color.black} fontWeight={600}>
        Start Date
      </DataTableEllipsisCell>
    ),
    renderCell: ({ value }) => (
      <DataTableEllipsisCell fontSize={['8px', '10px', '10px', '12px']} color={theme.color.black}>
        {dayjs(value).format('MMM D, YYYY')}
      </DataTableEllipsisCell>
    ),
  },
  {
    id: 3,
    flex: 1,
    field: 'expireDate',
    sortable: false,
    renderHeader: () => (
      <DataTableEllipsisCell fontSize={['10px', '10px', '12px', '14px']} color={theme.color.black} fontWeight={600}>
        Expire Date
      </DataTableEllipsisCell>
    ),
    renderCell: ({ value }) => (
      <DataTableEllipsisCell fontSize={['8px', '10px', '10px', '12px']} color={theme.color.black}>
        {dayjs(value).format('MMM D, YYYY')}
      </DataTableEllipsisCell>
    ),
  },
  {
    id: 4,
    flex: 1,
    field: 'available',
    sortable: false,
    renderHeader: () => (
      <DataTableEllipsisCell fontSize={['10px', '10px', '12px', '14px']} color={theme.color.black} fontWeight={600}>
        Available
      </DataTableEllipsisCell>
    ),
    renderCell: ({ value }) => (
      <DataTableEllipsisCell fontSize={['8px', '10px', '10px', '12px']} color={theme.color.black}>
        {value}
      </DataTableEllipsisCell>
    ),
  },
  {
    id: 5,
    flex: 1,
    field: 'used',
    sortable: false,
    renderHeader: () => (
      <DataTableEllipsisCell fontSize={['10px', '10px', '12px', '14px']} color={theme.color.black} fontWeight={600}>
        Used
      </DataTableEllipsisCell>
    ),
    renderCell: ({ value }) => (
      <DataTableEllipsisCell fontSize={['8px', '10px', '10px', '12px']} color={theme.color.black}>
        {value}
      </DataTableEllipsisCell>
    ),
  },
  {
    id: 6,
    flex: 1,
    field: 'remaining',
    sortable: false,
    renderHeader: () => (
      <DataTableEllipsisCell fontSize={['10px', '10px', '12px', '14px']} color={theme.color.black} fontWeight={600}>
        Remaining
      </DataTableEllipsisCell>
    ),
    renderCell: ({ value }) => (
      <DataTableEllipsisCell fontSize={['8px', '10px', '10px', '12px']} color={theme.color.black}>
        {value}
      </DataTableEllipsisCell>
    ),
  },
  ...(isInvoiceColumnVisible
    ? [
        {
          id: 7,
          flex: 1,
          field: 'invoice',
          sortable: false,
          renderHeader: () => (
            <Flex width="100%" justifyContent="center">
              <DataTableEllipsisCell
                fontSize={['10px', '10px', '12px', '14px']}
                color={theme.color.black}
                fontWeight={500}>
                Invoice
              </DataTableEllipsisCell>
            </Flex>
          ),
          renderCell: ({ row: { invoiceNumber, invoiceUrl } }) =>
            invoiceUrl ? (
              <InvoiceCell invoiceUrl={invoiceUrl} invoiceNumber={invoiceNumber} />
            ) : (
              <Flex width="100%" height="100%" alignItems="center">
                <DataTableEllipsisCell fontSize={['8px', '10px', '10px', '12px']} color={theme.color.black}>
                  Part of contract
                </DataTableEllipsisCell>
              </Flex>
            ),
        },
      ]
    : []),
];
